import { render } from "./JobStatusView.vue?vue&type=template&id=610fba84&scoped=true"
import script from "./JobStatusView.vue?vue&type=script&lang=js"
export * from "./JobStatusView.vue?vue&type=script&lang=js"

import "./JobStatusView.vue?vue&type=style&index=0&id=610fba84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610fba84"]])

export default __exports__